const endpoints = {
  tokenEndPoints:  {
    userInfo: "/user/details",
    userEdit: "/user/edit",
    getAllPlans:  "/plan/getall",
    addPlan: "/add-plan",
    deletePlanById: "/plan/delete",
    editPlan:  "/plan/edit",
    planStatus:  "/plan/status",
    supportEnquires: "/user/support-enquiries",
    addSupportRequest: "/user/add-support-request",
    getWithdrawls: "/user/get-withdrawals",
    addWithdrawls: "/user/add-withdrawal-request",
    createWallet: "/create-wallet",
    walletDetails: "/wallet-details",
    getOrCreateWallet: "/get-wallet-details",
    walletTransactions: "/wallet-transactions",
    createWalletTransaction: "/create-wallet-transactions",
    updateWalletBalance: "/wallet/update-balance",
    purchasePlan: "/plan/purchase",
    getPurchasedPlansByUser: "/plan/user",
    sendOtp: "/sendotp",
    verifyOtp: "/verifyotp",
    savetempuser: "/save-temp-user",
    getActiveWallet: "/get-active-wallet",
    resetPassword: "/change-password",
    topupWallet: "/topup-request",
    topupTransactions: "/topup-transactions",

    getReferralsListing: "/referrals/listing",
    getReferralsMilestone: "/referrals/milestones",
    getReferralDashboard: "/referrals/dashboard",
    getReferralsListing: "/referrals/listing",
    getReferralsMilestone: "/referrals/milestones",
    getReferralDashboard: "/referrals/dashboard",

    portfolioSummary: "/portfolio-summary",

    notifications: "/notifications",
  },
  tokenLessEndPoints: {
    login: "/user/login",
    findByEmail: "/user/find-by-email",
  tokenLessEndPoints: {
    login: "/user/login",
    findByEmail: "/user/find-by-email",
    addUser: "/user/add-user",
    auth: "/auth",
  },
    auth: "/auth",
  },
};


export default endpoints;
